import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fileType-damage",
  "use": "fileType-damage-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"fileType-damage\"><defs><symbol id=\"fileType-damage_file-break\" data-name=\"file-break\" viewBox=\"0 0 20 20\"><path d=\"M15.77,0H7.68L8.74,4.53,6.53,9.16l.11,5.58L5.26,9.16l2-4.63L5.72,0H0V20H20V4.23Zm0,4.37V.28l4.08,4.08Z\" fill=\"#bfbfbf\" fill-rule=\"evenodd\" /></symbol></defs><title>fileType-damage</title><g id=\"fileType-damage_图层_2\" data-name=\"图层 2\"><g id=\"fileType-damage_图层_1-2\" data-name=\"图层 1\"><use width=\"20\" height=\"20\" xlink:href=\"#fileType-damage_file-break\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fileType-damage.svg
// module id = Gri2
// module chunks = 264